import "./src/styles/global.css"

export const onRouteUpdate = () => {
  window.previousPath = window.location.hostname
}
